import Phaser from 'phaser';
import { hardenUiKitTextures, preloadUiKit } from '../ui/kit';
import { hardenGameIconTextures, preloadGameIcons } from '../ui/icons';

/**
 * Loads UI fonts (via CSS @font-face), temporary UI kit, Phosphor icons,
 * and combat placeholders.
 */
export class PreloadScene extends Phaser.Scene {
  constructor() {
    super('Preload');
  }

  preload(): void {
    this.load.image('ui-slot-empty', 'assets/ui/slot-empty.png');
    this.load.image(
      'hero-vanguard-preview',
      'assets/ui/hero/vanguard-preview.png',
    );
    preloadUiKit(this);
    preloadGameIcons(this);
  }

  create(): void {
    const start = (): void => {
      hardenUiKitTextures(this);
      hardenGameIconTextures(this);
      this.createPlaceholderTextures();
      this.scene.start('Village');
    };
    if (typeof document !== 'undefined' && document.fonts?.ready) {
      document.fonts.ready.then(start).catch(start);
    } else {
      start();
    }
  }

  private createPlaceholderTextures(): void {
    this.makeSolidTexture('px-enemy', 96, 96, 0xc45c5c);
    this.makeSolidTexture('px-hero', 72, 96, 0x5b8def);
    this.makeSolidTexture('px-die', 56, 56, 0xf2e6c8);
    this.makeSolidTexture('px-die-locked', 56, 56, 0x3a4158);
    this.makeSolidTexture('px-btn', 140, 44, 0xc9a227);
    this.makeSolidTexture('px-btn-sm', 88, 40, 0xc9a227);
    this.makeSolidTexture('px-panel', 8, 8, 0x161b2e);
  }

  private makeSolidTexture(
    key: string,
    width: number,
    height: number,
    color: number,
  ): void {
    if (this.textures.exists(key)) {
      return;
    }
    const g = this.make.graphics({ x: 0, y: 0 });
    g.fillStyle(color, 1);
    g.fillRoundedRect(0, 0, width, height, 6);
    g.lineStyle(2, 0xffffff, 0.35);
    g.strokeRoundedRect(1, 1, width - 2, height - 2, 6);
    g.generateTexture(key, width, height);
    g.destroy();
  }
}
